import { apiClient } from './apiClient';

class UsersService {
  async getUsers(params = {}) {
    try {
      const query = new URLSearchParams();
      if (params.search) query.append('search', params.search);
      if (params.role) query.append('role', params.role);

      const response = await apiClient.get(`/auth/users${query.toString() ? `?${query}` : ''}`);
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Fehler beim Laden der Benutzer:', error);
      return {
        success: false,
        error: error.message || 'Benutzer konnten nicht geladen werden.',
        data: []
      };
    }
  }

  async createUser({ username, password, role, venue }) {
    try {
      const response = await apiClient.post('/auth/users', { username, password, role, venue });
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Fehler beim Anlegen des Benutzers:', error);
      return {
        success: false,
        error: error.message || 'Benutzer konnte nicht angelegt werden.'
      };
    }
  }

  async updateUser(id, payload) {
    try {
      const response = await apiClient.put(`/auth/users/${id}`, payload);
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Benutzers:', error);
      return {
        success: false,
        error: error.message || 'Benutzer konnte nicht aktualisiert werden.'
      };
    }
  }

  async deleteUser(id) {
    try {
      await apiClient.delete(`/auth/users/${id}`);
      return {
        success: true
      };
    } catch (error) {
      console.error('Fehler beim Löschen des Benutzers:', error);
      return {
        success: false,
        error: error.message || 'Benutzer konnte nicht gelöscht werden.'
      };
    }
  }

  async resetPassword(id, password) {
    try {
      const response = await apiClient.post(`/auth/users/${id}/reset-password`, { password });
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Fehler beim Zurücksetzen des Passworts:', error);
      return {
        success: false,
        error: error.message || 'Passwort konnte nicht zurückgesetzt werden.'
      };
    }
  }
}

const usersService = new UsersService();
export default usersService;

